import React, { useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';

import {
  BoxContainer,
  Breadcrumb,
  CustomButton,
  Loader,
  Typography,
} from '../../components';
import { fromUserRoleToUrl, Role, URLS } from '../../utils';
import AvailableComponent from '../../utils/AvailableComponent';
import { PaginationData } from '../../utils/types';
import useStore from '../../zustand';
import SemitrailersTable from './components/SemitrailersTable';
import useSemitrailersTable from './hooks/useSemitrailers';
import { StyledActionsContainer } from './Semitrailers.styled';

const PageContent = () => {
  const navigate = useNavigate();

  const [userRole] = useStore((state) => [state.userRole]);
  const transformedUserRole = fromUserRoleToUrl(userRole);

  const breadcrumbItems = [
    { location: URLS.dashboard, name: 'Dashboard' },
    {
      location: URLS.semitrailers,
      name: 'Semiremolques',
      withUserRole: true,
    },
  ];

  const handleOnClickNewSemitrailer = React.useCallback(() => {
    navigate(`/${transformedUserRole}${URLS.addSemitrailer}`);
  }, []);

  const [currentPage, setCurrentPage] = useState(1);
  const paginationData: PaginationData = {
    pageSize: 20,
    current: currentPage,
    onChange: setCurrentPage,
  };

  const {
    data,
    handleDeleteSemitrailer,
    onCheckboxFilterChange,
    onInputFilterChange,
    totalResults,
    isLoading,
    handleTableChange,
  } = useSemitrailersTable({ paginationData });

  return (
    <BoxContainer $useMarginBottom $useMarginTop>
      <Breadcrumb items={breadcrumbItems} />

      {isLoading && <Loader />}
      <Typography theme="h1" $marginBottom="2rem">
        Semiremolques
      </Typography>
      <StyledActionsContainer>
        <CustomButton
          $isMini
          $marginBottom="6rem"
          onPress={handleOnClickNewSemitrailer}
          text="Nuevo Semiremolque"
        />
        <AvailableComponent availableFor={[Role.Transporter]}>
          <Link to={`/${transformedUserRole}/polizas`}>
            <CustomButton
              $isMini
              $marginBottom="6rem"
              text="Actualizar Pólizas"
              $theme="secondary"
            />
          </Link>
        </AvailableComponent>
      </StyledActionsContainer>
      <SemitrailersTable
        data={data}
        onDeleteSemitrailer={handleDeleteSemitrailer}
        onInputCheckboxChange={onCheckboxFilterChange}
        onInputFilterChange={onInputFilterChange}
        paginationData={{
          ...paginationData,
          total: totalResults,
        }}
        onTableChange={handleTableChange}
      />
    </BoxContainer>
  );
};

export default PageContent;
